import { VueConstructor } from "vue";

export default {
  install(Vue: VueConstructor) {
    // Vue.Component()
  }
};
